import React from 'react';
import './guess-you-love.scss';
import helper from '../../helper/dish-helper';
import guessyouloveIcon from '../../asset/images/guessyoulove.svg';
import guessyoulovechangeIcon from '../../asset/images/guessyoulove-change.svg';
import DishListItem from '../dish-menu/dish-list-item.jsx';
import HttpsProtocolImage from '../../component/common/https-protocol-image';
import classnames from 'classnames';

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import dishMenuMessages from '../../intl/messages/dish-menu';

class GuessYouLove extends React.Component {
  static dishPlayName = 'GuessYouLove';

  static propTypes = {
    recommendDishList: React.PropTypes.array.isRequired,
    dishesDataDuplicate: React.PropTypes.array,

    onOrderBtnTap: React.PropTypes.func,
    onPropsBtnTap: React.PropTypes.func,
    redirectToGoodsDetail: React.PropTypes.func, // 跳转连接的方法
    recommendDishListOuterStyle: React.PropTypes.object,
    // 来源判断
    fromWay: React.PropTypes.string, // 引用来源
    linkType: React.PropTypes.bool, // 点击之后是跳转链接
    isSync: React.PropTypes.bool, // 是否是协同购物车
    outerClassName: React.PropTypes.string, // 最外层class 用于唯一性
  };

  static defaultProps = {
    recommendDishList: [],
    outerClassName: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      partNumber: 3,
    };

    this.onDishBtnTap = this.onDishBtnTap.bind(this);
  }

  componentDidMount() {
    // 计算猜你喜欢图片需要的长和宽
    setTimeout(() => {
      this.calcWidthAndHeight();
    }, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.initDishNumber) {
      this.setState({ partNumber: nextProps.initDishNumber });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // 计算猜你喜欢图片需要的长和宽
    /*
    if (this.state.partNumber !== prevState.partNumber) {
      this.calcWidthAndHeight();
    }
    */
  }

  calcWidthAndHeight() {
    // const { outerClassName } = this.props;
    const recommendDishListInner = this.refs.recommendDishListInner;

    if (!recommendDishListInner) {
      return;
    }

    const offsetWidth = recommendDishListInner.offsetWidth;
    const needImgWidth = Math.floor((offsetWidth - 15 * 2 - 8 * 2) / 3);

    this.setState({ needImgWidth });
  }

  onDishBtnTap(dishData, action) {
    const { onOrderBtnTap, onPropsBtnTap, fromWay, isSync } = this.props;
    if (action) {
      this.onOrderDishUpdateInfo = {
        dishData,
        action,
      };
      if (fromWay === 'DishMenuCart') {
        const _increment = helper.adjustOrderedDishIncrement(dishData, action);
        if (isSync) {
          onOrderBtnTap(Object.assign({}, dishData), _increment);
        } else {
          onOrderBtnTap(Object.assign({}, dishData, { order: _increment || 1 }), action);
        }
      } else {
        onOrderBtnTap(dishData, action);
      }
    } else {
      onPropsBtnTap(dishData);
    }
  }

  redirectToGoodsDetail(id) {
    const { redirectToGoodsDetail } = this.props;

    if (redirectToGoodsDetail) {
      this.props.redirectToGoodsDetail(id);
    }
  }

  setDishTypeData(theme, onDishBtnTap, dishData, dishesData, idx) {
    const { linkType } = this.props;
    const { needImgWidth } = this.state;
    const changeShowData = helper.getOrderedDishes(dishesData);
    const changeShowDataItems = changeShowData.reduce((changeItems, itemt) => {
      changeItems[itemt.id] = itemt;
      return changeItems;
    }, {});

    const imgUrl = dishData.smallImgUrl;
    const dishImageStyle =
      imgUrl && dishData ? { backgroundImage: `url(${HttpsProtocolImage.getFinalImageUrl(imgUrl)})`, height: needImgWidth } : { height: needImgWidth };
    const newItem = (
      <li className="dish-item-dish" style={{ width: needImgWidth }} key={idx}>
        {!linkType ? (
          <DishListItem
            changeShowDataItems={changeShowDataItems}
            theme={theme}
            dishData={dishData}
            onOrderBtnTap={onDishBtnTap}
            onPropsBtnTap={onDishBtnTap}
            onImageBtnTap={() => {}}
            marketList={{}}
            diningForm={1}
            hotTag={false}
            showHandleInput={() => {}}
            onlyAddCounter
            needImgWidth={needImgWidth}
          />
        ) : (
          <div className="dish-on-selling" onTouchTap={() => this.redirectToGoodsDetail(dishData.id)}>
            <div className="dish-list-item">
              <div className={classnames('dish-item-img', { 'dish-img-default': !dishData.smallImgUrl })} style={dishImageStyle}></div>
              <div className="dish-item-content">
                <div className="dish-item-fill">
                  <span className="dish-item-name">
                    {dishData.name}
                    {dishData.unitName !== '份' ? '/' + dishData.unitName : ''}
                  </span>
                </div>
                <div className="dish-item-bottom">
                  <div className="dish-price-container">
                    <span className="dish-item-price">
                      <span className="dish-item-price-number dish-item-price-nosub price">{dishData.marketPrice}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </li>
    );

    return newItem;
  }

  buildDishElements(dishesData, onDishBtnTap) {
    return dishesData.map(dishData => this.setDishTypeData('default', onDishBtnTap, dishData, dishesData, dishData.id));
  }

  getDishesDataDuplicateNew() {
    const { recommendDishList, dishesDataDuplicate, fromWay, linkType } = this.props;
    let dishesDataDuplicateNew = [];

    if (linkType) {
      dishesDataDuplicateNew = recommendDishList;
      return dishesDataDuplicateNew;
    }

    switch (fromWay) {
      case 'DishMenuCart':
        dishesDataDuplicateNew = dishesDataDuplicate;
        break;
      default:
        recommendDishList.forEach(item => {
          const findObj = dishesDataDuplicate.find(itemt => itemt.id === item.id);
          if (findObj) {
            dishesDataDuplicateNew.push(findObj);
          }
        });
        break;
    }

    return dishesDataDuplicateNew;
  }

  formatRecommendDishList() {
    return this.dishElementsLength;
  }

  render() {
    const { partNumber } = this.state;
    const { recommendDishListOuterStyle, initDishNumber = 3 } = this.props;
    const dishesDataDuplicateNew = this.getDishesDataDuplicateNew();
    const dishElements = this.buildDishElements(dishesDataDuplicateNew, this.onDishBtnTap);
    const dishElementsLength = dishElements.length;
    this.dishElementsLength = dishElementsLength;
    const dishElementsLimit = dishElements.slice(partNumber - initDishNumber, partNumber);

    if (dishElementsLength === 0) {
      return <div></div>;
    }

    return (
      <div className="recommendDishList__holder" style={recommendDishListOuterStyle}>
        <div className="recommendDishList__inner" ref="recommendDishListInner">
          <div className="o-flex o-fz--16 o-ta--c o-fw--b recommendDishList__title">
            <img src={guessyouloveIcon} alt="猜你喜欢" className="recommendDishList__title__img" />
            <FormattedMessage {...dishMenuMessages.guessYouLove} />
            {dishElementsLength > initDishNumber && (
              <i className="o-flex o-fz--13 recommendDishList__switch">
                <img src={guessyoulovechangeIcon} alt="换一批" className="recommendDishList__switch__img" />
                <i className="recommendDishList__switch__i">{formatMessage(dishMenuMessages.changeView)}</i>
              </i>
            )}
          </div>
          <div className="recommendDishList default">
            <ul className="recommendDishList__ul">
              {dishElementsLimit}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default GuessYouLove;



// WEBPACK FOOTER //
// ./src/component/common/guess-you-love.jsx